import styles from "./styles.module.scss";
import cx from "classnames";
import { FormControl } from "react-bootstrap";
import ColorPicker from "../colorPicker";

// Viewer
export const ThemeCustomizationViewer = ({buttonColor, buttonTextColor}: {buttonColor: string, buttonTextColor: string}) => (
  <div className={styles.viewerContainer}>
    <div className={styles.innerContainer}>
      <p className={styles.header}>
             Please enter your email here
      </p>
      <div className={styles.subContainer}>
        <FormControl
             placeholder={"Enter your work mail"}
            disabled={true}
            className={cx(styles.input)}
              />
      </div>
    </div>
      <button
         className={styles.actionButton}
          disabled={true}
          style={{backgroundColor: buttonColor, color: buttonTextColor}}  
      >
        <i className="paperflite-tick"></i> Continue
      </button>
 </div>
);

// Editor
export const ThemeCustomizationEditor = ({primaryColor, buttonColor, onColorChange}: {primaryColor: string, buttonColor: string, onColorChange: (title:string,color: string) => void}) => (
  <div className={styles.editorContainer}>
    <div className={styles.header}>
       <h5 className={styles.title}>Customize Theme</h5>
       <p className={styles.subText}>Design your themes in a way that's unique to your organisation. Customise colours and fonts to suit your brand's theme or for that matter, your moods.</p>
    </div>
    <div className={styles.innerContainer}>
      <div className={styles.subContainer}>
           <ColorPicker 
              title="Primary Color"
              hexColor={primaryColor}
              onColorChange={(color)=> onColorChange("primaryColor", color)}
            />
            <ColorPicker 
              title="Button Text Color"
              hexColor={buttonColor}
              onColorChange={(color)=> onColorChange("buttonTextColor", color)}
            />
      </div>
    </div>
 </div>
);
